<template>
  <div>
    <div class="update-v" v-if="showVersionTip">
      <div><i class="el-icon-warning-outline" style="margin-right: 4px;"></i>新版本已就绪，请刷新重试！</div>
      <el-button type="primary" size="mini" @click="refreshPage" style="padding: 4px;">刷新</el-button>
    </div>
    <div
      class="app-layout"
      :class="layoutClassName"
    >
      <div
        v-if="sidebar.opened && screenSize === 'screen-xs'"
        @click="handleClickOutside"
        class="app-layout-sider-mask"
      ></div>
      <app-sider />

      <section class="app-layout-main">
        <app-header />
        <app-body />
        <app-footer />
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  AppSider,
  AppHeader,
  AppBody,
  AppFooter,
} from './components/index';
import ResizeMixin from './mixins/resize-handler';

export default {
  name: 'Layout',
  components: {
    AppSider,
    AppHeader,
    AppBody,
    AppFooter,
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters('app', [
      'sidebar',
      'device',
      'screenSize',
      'showVersionTip',
    ]),
    layoutClassName() {
      const { screenSize, sidebar } = this.$store.state.app;
      return {
        [screenSize]: screenSize,
        'sidebar-show': sidebar.opened,
        'sidebar-hide': !sidebar.opened,
        'without-animation': sidebar.withoutAnimation,
      };
    },
  },
  methods: {
    ...mapActions('app', [
      'closeSideBar',
    ]),
    handleClickOutside() {
      this.closeSideBar({ withoutAnimation: false });
    },
    refreshPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
body {
  &.sidebar-show {
    overflow: hidden;
    position: relative;
    width: calc(100% - 17px);
  }
}
.app-layout {
  display: flex;
  flex-direction: row;

  &.without-animation {
    .app-layout-sider {
      transition: none;
    }
  }

  &-main {
    flex: auto;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    position: relative;
    overflow: hidden;

    a {
      color: $color-link;
    }
  }

  // 侧边栏显示
  &.sidebar-show {
    .app-layout-sider {
      width: $app-sider-width;
    }

    .app-layout-main {
      padding-left: $app-sider-width;
    }

    .app-layout-header.fixed {
      .app-layout-header-inner {
        width: calc(100% - #{$app-sider-width});
      }
    }
  }

  // 侧边栏隐藏
  &.sidebar-hide {
    .app-layout-sider {
      width: $app-sider-width-min;
    }

    .app-layout-main {
      padding-left: $app-sider-width-min;
    }

    .app-layout-header.fixed {
      .app-layout-header-inner {
        width: calc(100% - #{$app-sider-width-min});
      }
    }
  }

  // 超小屏
  &.screen-xs {
    .app-layout-main {
      padding-left: 0;
    }

    .app-layout-header.fixed {
      .app-layout-header-inner {
        width: 100%;
      }
    }

    .app-layout-sider {
      width: $app-sider-width !important;
    }

    // 侧边栏显示

    // 侧边栏隐藏
    &.sidebar-hide {
      .app-layout-sider {
        pointer-events: none;
        transform: translate3d(-$app-sider-width, 0, 0);
        box-shadow: none;
      }
    }
  }
}

.update-v {
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff8f0;
  padding: 0 16px;
  height: 44px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffa040;
  line-height: 20px;
}
</style>
